var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_424",
    "data-name": "Caminho 424",
    d: "M0,0H22.48V16.542l-4.191.356-11.2-.914-7.768,2.7Z",
    transform: "translate(37 492.23)",
    fill: "#fff",
    opacity: 0.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1775",
    "data-name": "Grupo 1775",
    transform: "translate(-30 -486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1774",
    "data-name": "Grupo 1774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1773",
    "data-name": "Grupo 1773"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_910",
    "data-name": "Ret\\xE2ngulo 910",
    width: 35,
    height: 35,
    rx: 10,
    transform: "translate(30 486)",
    fill: "#b895ff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "noun-headset-1237338",
    d: "M167.262,76.1v-.65a8.253,8.253,0,1,0-16.505,0v.65a2.95,2.95,0,0,0-2.358,2.887v2.358a2.947,2.947,0,1,0,5.895,0V78.985a2.95,2.95,0,0,0-2.358-2.887v-.65a7.074,7.074,0,0,1,14.147,0v.65a2.95,2.95,0,0,0-2.358,2.887v2.358a2.95,2.95,0,0,0,2.358,2.887v1.3l-4.2.467a2.947,2.947,0,1,0,.024,1.183l4.835-.538a.589.589,0,0,0,.525-.586V84.23a2.95,2.95,0,0,0,2.358-2.887V78.985a2.95,2.95,0,0,0-2.358-2.887Zm-14.147,2.887v2.358a1.768,1.768,0,1,1-3.537,0V78.985a1.768,1.768,0,1,1,3.537,0Zm5.895,9.431a1.769,1.769,0,1,1,1.769-1.769A1.771,1.771,0,0,1,159.009,88.417Zm9.431-7.074a1.769,1.769,0,1,1-3.537,0V78.985a1.769,1.769,0,1,1,3.537,0Z",
    transform: "translate(-111.399 424.804)",
    fill: "#b895ff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_m\\xE1scara_1",
    "data-name": "Grupo de m\\xE1scara 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-headset-1237338-2",
    "data-name": "noun-headset-1237338",
    d: "M167.262,76.1v-.65a8.253,8.253,0,1,0-16.505,0v.65a2.95,2.95,0,0,0-2.358,2.887v2.358a2.947,2.947,0,1,0,5.895,0V78.985a2.95,2.95,0,0,0-2.358-2.887v-.65a7.074,7.074,0,0,1,14.147,0v.65a2.95,2.95,0,0,0-2.358,2.887v2.358a2.95,2.95,0,0,0,2.358,2.887v1.3l-4.2.467a2.947,2.947,0,1,0,.024,1.183l4.835-.538a.589.589,0,0,0,.525-.586V84.23a2.95,2.95,0,0,0,2.358-2.887V78.985a2.95,2.95,0,0,0-2.358-2.887Zm-14.147,2.887v2.358a1.768,1.768,0,1,1-3.537,0V78.985a1.768,1.768,0,1,1,3.537,0Zm5.895,9.431a1.769,1.769,0,1,1,1.769-1.769A1.771,1.771,0,0,1,159.009,88.417Zm9.431-7.074a1.769,1.769,0,1,1-3.537,0V78.985a1.769,1.769,0,1,1,3.537,0Z",
    transform: "translate(-111.399 424.804)",
    fill: "#b895ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.16eedc7763304012941b3841cb2440c1.svg";
export { ForwardRef as ReactComponent };